export interface ICenterFiveStarWeightedAverageResults {
    centerId: number,
    workupTreatmentCoeff: number,
    workupConvenienceCoeff: number,
    workupFacilityCoeff: number,
    preOpTreatmentCoeff: number,
    preOpConvenienceCoeff: number,
    preOpFacilityCoeff: number,
    surgeryTreatmentCoeff: number,
    surgeryConvenienceCoeff: number,
    surgeryFacilityCoeff: number,
    surgeryDonorSurgeonCoeff: number,
    surgeryNursingCoeff: number,
    surgeryPainManagementCoeff: number,
    surgeryCaretakerCoeff: number,
    overallTotal: number,
    overallAverage: number,
    centerTotal: number,
    centerAverage: number,
    centerScoreNumerator: number,
    centerScoreDenominator: number,
}
